import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addCard, types as paymentTypes } from 'legacy/actions/paymentActions';
import { clearHistory, clearModal } from 'legacy/actions/modalActions';

import { withForm } from '../../util/FormHelpers';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { store } from '../../../store';
import ModalContent from './components/ModalContent';

interface AddCardProps {
  nextComponent?: React.ReactNode;
  // Allow any additional props to be passed through
  [key: string]: any;
}

class AddCard extends Component<any> {
  render() {
    return (
      <Modal
        type={ModalType.SMALL}
        visible
        disableAnimationOnWeb
        onClose={() => {
          store.dispatch(clearModal());
        }}
      >
        <ModalContent {...(this.props as any)} />
      </Modal>
    );
  }
}

const actions = {
  addCard,
  clearHistory
};

const mapStateToProps = (state: any) => ({
  user: state.user.user,
  payment: state.payment,
  stripeHasLoaded: state.app.stripeHasLoaded,
  device: state.app.device
});

const ConnectedComponent = connect(
  mapStateToProps,
  actions
)(withForm((paymentTypes as any).ADD_CARD_FORM)(AddCard));

export default ConnectedComponent;
